<script lang="ts" generics="TValues, TValue">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { cx } from '$lib/utils/cx';

    export let label: string;
    export let help: string | null = null;

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;
    export let required: boolean = false;

    let className = '';
    export { className as class };

    export let defaultClass: string = 'flex flex-col gap-0 mb-[5px] text-balance';

    export let labelClass: string = '';
    export let defaultLabelClass: string = 'form-label m-0';

    export let helpClass: string = '';
    export let defaultHelpClass: string = 'text-gray-600';

    export let id: string = form.getFieldId(field);

    $: nbSubmits = form.stores().nbSubmits();
    $: isAlreadyBlur = form.stores().isAlreadyBlur(field);
    $: hasAnyErrors = form.stores().hasFieldAnyErrors(field);
</script>

<div class={cx(defaultClass, className)}>
    <label
        class={cx(
            labelClass,
            defaultLabelClass,
            'form-label',
            ($nbSubmits > 0 || $isAlreadyBlur) && $hasAnyErrors
                ? 'form-label--invalid'
                : '',
        )}
        for={id}
    >
        <slot {field} {form} {required}>
            {label}{required ? '*' : ''}
        </slot>
    </label>

    <slot name="help" {field} {form} {required}>
        {#if help != null}
            <span class={cx(helpClass, defaultHelpClass)}>
                {help}
            </span>
        {/if}
    </slot>
</div>
